jQuery(document).ready(function() {
jQuery('.item-slider').slick({
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    responsive: [
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 4
      }
    }
  ]
  });  
  //------- Custom Arrows click functionality
  jQuery(document).on('click', '.prevSlide', function(){
    jQuery('.item-slider').slick('slickPrev');
  });  
  jQuery(document).on('click', '.nextSlide', function(){
    jQuery('.item-slider').slick('slickNext');
  });  
  //------- Click to filter slides according to user's choice  
  jQuery(document).on('click', '.services-list li a', function(){
      jQuery('.services-list li a').removeClass('active');
        jQuery(this).addClass('active');
        var cat = jQuery(this).attr('data-category');
        jQuery.get(wp.ajax_url , { 'category_slug': cat, 'action': "product_list"}, function(data){
            jQuery('.slider-wrapper').html(data);
            jQuery('.item-slider').slick({
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 4
                        }
                    }
                ]
            });
        });
      });	
});
